import TokensEdit from './TokensEdit';

const tokens =
{
    edit: TokensEdit
};

export default tokens;
